'use client';
import './Contact.css';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import { useState } from 'react';
import { toast } from 'react-toastify';
import contactApi from '../../services/contactApi';

const ContactPage = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        name: formData.name,
        email: formData.email,
        message: formData.comment,
      };

      const response = await contactApi.contact(payload);

      if (response.success) {
        toast.success(response.message || 'Message sent successfully');
        setFormData({ name: '', email: '', comment: '' });
        setIsSubmitted(true);
        setLoading(false);

      } else if (response.error) {
        toast.error(response.error || 'Failed to send message');
        setLoading(false);
      } else {
        toast.error('Failed to send message');
        setLoading(false);
      }

    } catch (error) {
      toast.error('Error sending message');
      setLoading(false);
      console.error(error);
    }
  };

  return (
    <div className="contact-container">
      <Header />
      <div className="contact-page">
        <div className="contact-header">
          <p>
            We're excited to hear from you and will do our best to respond to your message as quickly as possible.
          </p>
        </div>
        <h2 className='Contact-Header mb-4'>Get in touch with us.</h2>
        {isSubmitted ? (
          <div className="response-received">
            <h2 className='thankyou'>Thank you! 🙂</h2>
            <p className='thanksMsg'>We’ve received your message.</p>
          </div>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className='form-flex'>
              <div className="form-group">
                <label htmlFor="name">Name
                  <span className="text-style-1">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder='Name'
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email
                  <span className="text-style-1">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder='Email'
                  required
                />
              </div>

            </div>
            <div className="form-group">
              <label htmlFor="comment">Comment
                <span className="text-style-1">*</span>
              </label>
              <textarea
                id="comment"
                name="comment"
                value={formData.comment}
                onChange={handleChange}
                placeholder="Type here..."
                required
              />
            </div>

            <button type="submit" disabled={loading} className="submit-button">
              {loading ? (
                <span className="loading-content">
                  <span className="spinner" /> Sending...
                </span>
              ) : (
                'Send'
              )}
            </button>

          </form>
        )}
      </div>
      <Footer />
    </div>

  );
};

export default ContactPage;